import { MprcSpinnerIndicator } from "components";
import { FeedItemDto, FeedType } from "generated/CoreApi_v1";
import { useMentionInterceptor } from "hooks/useMentionInterceptor";
import { useCoreApi } from "providers/CoreApiProvider";
import { useEffect, useRef, useState } from "react";
import { CardManager } from "views/knowledge/components/card/CardManager";
import { FeedCustomEventProps, subscribe, unsubscribe } from "views/knowledge/feed/FeedEvents";

interface IProps {
    publicationId: string;
    onError: (e: any) => void;
}

export const PostThreads: React.FC<IProps> = (props) => {

    const { publicationId, onError } = props;

    const api = useCoreApi();
    const [mentionDialog] = useMentionInterceptor("postThreadsContainer");

    const [loadingThread, setLoadingThread] = useState<boolean>(false);
    const [threadItems, setThreadItems] = useState<FeedItemDto[]>([]);
    // Armazena lista para atualizar o state quando necessário.
    // useState de threadItems é limpo ao adicionar uma nova postagem na thread pela ação do subscribe.
    const threadItemsData = useRef<FeedItemDto[]>([]);

    ///
    const handleNewThreadItem = (e: FeedCustomEventProps) => {
        if (e.detail) loadThreadItem(e.detail);
    };

    ///
    const handleThreadReload = (e: FeedCustomEventProps) => {
        loadThreads();
    };

    ///
    const onThreadDataItemChanged = (index: number, data: Partial<FeedItemDto>) => {
        threadItemsData.current[index] = {...threadItemsData.current[index], ...data};
        setThreadItems([...threadItemsData.current]);
    };

    ///
    const loadThreadItem = async (publicationId: string) => {
        setLoadingThread(true);
        try {
            const result = await api.v1.knowledgeFeed.getFeedItem({ publicationId });
            if (!threadItemsData.current.find(t => t.publicationId == publicationId)) {
                threadItemsData.current = [...threadItemsData.current, result.data];
            } else {
                threadItemsData.current = threadItemsData.current.map(obj => {
                    if (obj.publicationId == publicationId) {
                        return { ...obj, ...result.data };
                    }
                    return obj;
                });
            }
            setThreadItems([...threadItemsData.current]);
        }
        catch (error: any) {
            onError(error);
        }
        finally {
            setLoadingThread(false);
        }
    };

    ///
    const loadThreads = async () => {
        threadItemsData.current = [];
        setLoadingThread(true);
        try {
            const result = await api.v1.knowledgeFeed.getFeedThreadItems({ masterPublicationId: publicationId! });
            threadItemsData.current = result.data;
            setThreadItems([...threadItemsData.current]);
        }
        catch (error: any) {
            onError(error);
        }
        finally {
            setLoadingThread(false);
        }
    };

    ///
    useEffect(() => {
        loadThreads();

        subscribe("TreadItemCreated", handleNewThreadItem);
        subscribe("TreadReload", handleThreadReload);
        return () => {
            unsubscribe("TreadItemCreated", handleNewThreadItem);
            unsubscribe("TreadReload", handleThreadReload);
        };
    }, [publicationId]);

    return (
        <div id="postThreadsContainer">
            {mentionDialog}
            {
                loadingThread
                    ? <MprcSpinnerIndicator />
                    : threadItems.map((item, index) => (
                        <CardManager
                            key={item.publicationId}
                            feedType={FeedType.ContentPage}
                            otherInfo={{ feedType: FeedType.ContentPage }}
                            pub={item}
                            onNeedResetRowHeight={() => { }}
                            onReload={() => loadThreadItem(item.publicationId)}
                            onFeedItemChanged={(data) => {
                                if (data.deletedOn) loadThreads();
                                else onThreadDataItemChanged(index, data);
                            }}
                        />
                    ))
            }
        </div>
    );
};
